import styled from "styled-components";
import { AppMenuButtonIconWrapper } from "../app-menu-button/AppMenuButton.styled";
import { MOBILE_BREAKPOINT } from "../constants";
import { AppNavListItem } from "./AppNavListItem.styled";
export const AppNavListItemTertiary = styled(AppNavListItem) `
  button svg {
    margin-right: 0;
  }

  @media (min-width: ${MOBILE_BREAKPOINT}px) {
    /* Button is nav height but content is aligned to bottom, because of this the tertiary icon wrapper
      won't be centered to the button text so need manual margin adjustment.
      */

    ${AppMenuButtonIconWrapper} {
      margin-bottom: ${({ isActive }) => (isActive ? "-2px" : 0)};
    }
  }
`;
export const AppNavListItemTertiaryMenuWrapper = styled.span `
  ul li a {
    padding-left: 0;
  }
`;
